import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import styles from './index.css';
import { rel } from '../../../../../utils/rel';

const TitleLine = errorBoundary(
    class extends PureComponent {
        static propTypes = {
            wemediaEAccountId: PropTypes.string,
            wemediaEAccountInfo: PropTypes.object,
            articleObj: PropTypes.object,
        };

        state = {
            honorNameShow: false,
        };

        showHonorName = () => {
            this.setState({
                honorNameShow: true,
            });
        };

        hideHonorName = () => {
            this.setState({
                honorNameShow: false,
            });
        };

        render() {
            const {
                wemediaEAccountId,
                wemediaEAccountInfo: {
                    wemediaEAccountName,
                    wemediaEAccountHead,
                    wemediaEAccountHonorImg,
                    wemediaEAccountHonorName,
                },
                articleObj: { title, newsTime },
            } = this.props;
            const { honorNameShow } = this.state;

            const wemediaHomePage = `//feng.ifeng.com/author/${wemediaEAccountId}`;

            return (
                <div className={styles.titleLine}>
                    <h1>{title}</h1>
                    <p>
                        {wemediaEAccountHead ? (
                            <a href={wemediaHomePage} target="_blank" rel={rel}>
                                <img src={wemediaEAccountHead} />
                            </a>
                        ) : null}
                        {wemediaEAccountId ? (
                            <a href={wemediaHomePage} target="_blank" rel={rel}>
                                {wemediaEAccountName}
                            </a>
                        ) : null}
                        {wemediaEAccountHonorImg && wemediaEAccountHonorName ? (
                            <a
                                className={styles.honorSystem}
                                onMouseEnter={this.showHonorName}
                                onMouseLeave={this.hideHonorName}>
                                <img src={wemediaEAccountHonorImg} />
                                <div className={`${styles.honorName} ${honorNameShow ? styles.show : styles.hide}`}>
                                    {wemediaEAccountHonorName}
                                </div>
                            </a>
                        ) : null}
                        {wemediaEAccountId ? (
                            <a href={wemediaHomePage} target="_blank" rel={rel} className={styles.getMore}>
                                &lt;更多内容
                            </a>
                        ) : null}
                        <span>{newsTime}</span>
                    </p>
                </div>
            );
        }
    },
);

export default TitleLine;
